<template>
  <div :style="maxHeight" style="overflow-y: auto;overflow-x: hidden">
    <div style="margin-left: 40px">
      <el-button v-if="this.parentData" type="success" :loading="loading" @click="deleteChartData">{{"数据修复"}}</el-button>
      <el-button type="primary">{{"物件选择"}}</el-button>
      <el-select v-model="wuJianId" @change="renderAllEcharts" clearable placeholder="物件名称" style="width: 200px;">
        <el-option
            v-for="item in wuJianNames"
            :key="item.value"
            :label="item.label"
            :value="item.value">
        </el-option>
      </el-select>
    </div>

    <el-row style="height: 60%;margin-top: 5px">
      <el-col :span="12" style="border-right: 8px solid whitesmoke;border-bottom: 8px solid whitesmoke;height: 100%">
        <div class="title">
          <span>{{'前处理不良占比'}}</span>
          <div class="space-between">
            <el-date-picker v-model="qcl.year" @change="getQclChart" format="YYYY 年" value-format="YYYY" clearable type="year" placeholder="年" style="width: 80px; margin-right: 10px" size="small"/>
            <el-date-picker v-model="qcl.month" @change="getQclChart" format="MM 月" value-format="MM" clearable type="month" placeholder="月" style="width: 70px; margin-right: 10px" size="small"/>
          </div>
        </div>
        <div v-loading="qclChartLoading" element-loading-text="数据加载中" style="width: 100%;height: 90%" id="qcl"/>
      </el-col>
      <el-col :span="12" style="border-bottom: 8px solid whitesmoke;height: 100%">
        <div class="title">
          <span>{{'喷涂不良占比'}}</span>
          <div class="space-between">
            <el-date-picker v-model="pt.year" @change="getPtChart" format="YYYY 年" value-format="YYYY" clearable type="year" placeholder="年" style="width: 80px; margin-right: 10px" size="small"/>
            <el-date-picker v-model="pt.month" @change="getPtChart" format="MM 月" value-format="MM" clearable type="month" placeholder="月" style="width: 70px; margin-right: 10px" size="small"/>
          </div>
        </div>
        <div v-loading="ptChartLoading" element-loading-text="数据加载中" style="width: 100%;height: 90%" id="pt"/>
      </el-col>
    </el-row>

    <KfDialog v-model="dialogVisible" :item="dialogItem">

      <template #footer>
        <div style="display: flex;flex-direction: column;align-items: center;justify-content: space-around;">
          <div style="width:100%; display: flex;flex-direction: row;align-items: center;justify-content: space-around;">
            <span style="font-size: 24px;">{{this.chartData.name}}</span>
            <el-input-number v-model="this.chartData.value"/>
          </div>
          <el-button style="margin-top: 20px" type="primary" @click="editChartData">{{"保存"}}</el-button>
        </div>
      </template>
    </KfDialog>

  </div>
</template>

<script>
import * as echarts from "echarts";

export default {
  name: "TuZhuangZhiJianPage",
  props: ['parentData'],
  data(){
    return{
      maxHeight:'',
      dialogVisible:false,
      loading:false,
      dialogItem:{
        title:'',
        width:'30%'
      },
      chartData:{},
      wuJianId:'',
      wuJianNames:[],
      qcl:{
        year:this.$common.getCurrentYearByMonth().toString(),
        month:'',
        field:'氟素'
      },
      pt:{
        year:this.$common.getCurrentYearByMonth().toString(),
        month:'',
        field:'粉体'
      },
      /*物件别不良推移*/
      optionWuJian: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        legend: {
          //data: ['Evaporation', 'Precipitation', 'Temperature']
        },
        grid: {
          left: '5%',
          right: '5%',
          bottom: '5%',
        },
        xAxis: [
          {
            type: 'category',
            data: [],
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '再手配数量',
            axisLabel: {
              formatter: '{value}'
            }
          },
        ],
        series: [
          {
            name: '再手配数量',
            type: 'bar',
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: []
          },
        ]
      },
      wuJianChartLoading:false,
      /*前处理不良占比*/
      optionQcl:{
        title: {
          text: '总数量',
          top: '45%',
          left: '49%',
          textAlign: 'center',
          textStyle: {
            color: 'black',
            fontSize: '26px',
            lineHeight: 30
          }
        },
        tooltip: {
          trigger: 'item',
          formatter: "{b} : {c} ({d}%)"
        },
        legend: {
          textStyle: {
            fontSize:14
          },
          type: 'scroll',
          orient: 'horizontal',
          top:0,
        },
        series: [
          {
            name: '不良项目',
            type: 'pie',
            radius: ['40%', '65%'],
            center: ['50%', '55%'],
            label:{
              show: true,
              fontSize:16,
              formatter: '{b},{d}%'
            },
            data: [
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      },
      qclChartLoading:false,
      /*喷涂不良占比*/
      optionPt:{
        title: {
          text: '总数量',
          top: '45%',
          left: '49%',
          textAlign: 'center',
          textStyle: {
            color: 'black',
            fontSize: '26px',
            lineHeight: 30
          }
        },
        tooltip: {
          trigger: 'item',
          formatter: "{b} : {c} ({d}%)"
        },
        legend: {
          textStyle: {
            fontSize:14
          },
          type: 'scroll',
          orient: 'horizontal',
          top:0,
        },
        series: [
          {
            name: '不良项目',
            type: 'pie',
            radius: ['40%', '65%'],
            center: ['50%', '55%'],
            label:{
              show: true,
              fontSize:16,
              formatter: '{b},{d}%'
            },
            data: [
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      },
      ptChartLoading:false,
    }
  },
  methods:{
    getMaxHeight() {
      let pageHeight = document.body.scrollHeight - 160;
      this.maxHeight = "height: "+pageHeight+"px;";
    },
    renderEcharts(id,option){
      if (document.getElementById(id)) {
        echarts.init(document.getElementById(id)).dispose();
        let chart = echarts.init(document.getElementById(id));
        chart.setOption(option)
        let _this = this
        if (id === 'fenti' || id === 'fusu') {
          chart.on('legendselectchanged', function (params) {
            if (params.name === "全部") {
              for (let item in params.selected) {
                params.selected[item] = params.selected['全部']
              }
              option.legend.selected = params.selected
              chart.clear()
              chart.setOption(option)
            }
          })
        }
        if (this.parentData) {
          chart.on('click', function (params) {
            _this.dialogVisible = true
            _this.dialogItem.title = params.seriesName
            _this.chartData.seriesName = params.seriesName
            _this.chartData.value = params.value
            _this.chartData.name = params.name
            _this.chartData.dataIndex = params.dataIndex
            _this.chartData.seriesIndex = params.seriesIndex
            _this.chartData.chartType = option.type
          })
        }
      }
    },

    renderAllEcharts(){
      /*this.getWuJianChart()*/
      this.getQclChart()
      this.getPtChart()
    },

    async deleteChartData(){
      this.loading = true
      let {data: res} = await this.$axios.post('bus/homePage/deleteChartData',"bus_tuzhuang_page");
      if (res.code !== 0) {
        this.$message.error('刷新失败！请重试')
      }else {
        this.$message.success('刷新成功！')
        this.renderAllEcharts()
      }
      this.loading = false
    },

    async editChartData(){
      switch (this.chartData.chartType){
        case "ftDrum_chart":
          this.fenTi.wujian_id = this.wuJianId
          this.chartData.query = this.fenTi
          break
        case "fsDrum_chart":
          this.fuSu.wujian_id = this.wuJianId
          this.chartData.query = this.fuSu
          break
      }
      this.chartData.model = "bus_tuzhuang_page"
      this.chartData.dataKey = this.$common.getChartDataKey(this.chartData)
      let {data: res} = await this.$axios.post('bus/homePage/editChartData',this.chartData);
      if (res.code !== 0) {
        this.$message.error('修改失败！请重试')
      }else {
        this.$message.success('修改成功！')
        this.dialogVisible = false
      }
      switch (this.chartData.chartType){
        case "ftDrum_chart":
          await this.getFenTiChart()
          break
        case "fsDrum_chart":
          await this.getFuSuChart()
          break
      }

    },

    async getWuJianInFo() {
      let {data: res} = await this.$axios.post('bus/datasource/getWuJianInFo');
      if (res.code !== 0) {
        this.$message.error('获取【物件信息】失败')
        return;
      }
      this.wuJianNames = res.data;
    },

    /*async getWuJianChart() {
      this.wuJianChartLoading = true

      let data = {
        wujian_id:this.wuJianId
      }
      let {data: res} = await this.$axios.post('bus/zaiShouPei/ZSPChart',data);
      if (res.code !== 0) {
        this.$message.error(res.message)
        this.wuJianChartLoading = false
        this.optionWuJian.series[0].data = null
      }else {
        if (res.data.XMonth) {
          this.optionWuJian.xAxis[0].data = res.data.XMonth
          this.optionWuJian.series[0].data = res.data.badNum
        }
      }
      this.renderEcharts('wuJianZaiShouPei',this.optionWuJian)

      this.wuJianChartLoading = false
    },*/

    async getQclChart() {
      this.qclChartLoading = true
      if (!this.qcl.year){
        this.qcl.year = this.$common.getCurrentYearByMonth().toString()
      }
      this.qcl.wujian_id = this.wuJianId
      let {data: res} = await this.$axios.post('bus/tuZhuang/getQclChart',this.qcl);
      if (res.code !== 0) {
        this.$message.error(res.message)
        this.qclChartLoading = false
      }else {
        this.optionQcl.series[0].data = res.data
        this.optionQcl.title.text = "合计\n" + this.$common.getPieSum(this.optionQcl.series[0].data).toLocaleString()
      }
      this.renderEcharts('qcl',this.optionQcl)

      this.qclChartLoading = false
    },

    async getPtChart() {
      this.ptChartLoading = true
      if (!this.pt.year){
        this.pt.year = this.$common.getCurrentYearByMonth().toString()
      }
      this.pt.wujian_id = this.wuJianId
      let {data: res} = await this.$axios.post('bus/tuZhuang/getPtChart',this.pt);
      if (res.code !== 0) {
        this.$message.error(res.message)
        this.ptChartLoading = false
      }else {
        this.optionPt.series[0].data = res.data
        this.optionPt.title.text = "合计\n" + this.$common.getPieSum(this.optionPt.series[0].data).toLocaleString()
      }
      this.renderEcharts('pt',this.optionPt)

      this.ptChartLoading = false
    },
  },

  created() {
    this.getMaxHeight()
    this.getWuJianInFo()
  },

  mounted() {
    // this.renderAllEcharts()
    this.getQclChart()
    this.getPtChart()
  }
}
</script>

<style scoped>
.pageContainer{
  display: flex;
  flex-direction: row;
  overflow: hidden;
  justify-content: space-around;
  width: 100%;
}
.size{
  width: 100%;
  height: 440px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.title{
  border-left: 3px solid steelblue;
  height: 25px;
  width: 80%;
  font-size: 16px;
  margin-left: 40px;
}
.space-between{
  display: flex;
  flex-direction: row;
  align-items: center;;
}
.chart_size{
  width: 530px;
  height: 260px
}

.asideContainer {
  width: 50%;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
}
</style>